const ACCOUNT_PROMPT_DELAY_MS = 1200

const shouldStartCloseCelebration = ({
  wasClosed,
  isClosed,
  editMode,
  userEdited,
}) => Boolean(!wasClosed && isClosed && editMode && userEdited)

module.exports = {
  ACCOUNT_PROMPT_DELAY_MS,
  shouldStartCloseCelebration,
}
